import React from "react";
import UrgentVisitIcon from "../../../components/Icons/UrgentVisitIcon";

interface IUrgentVisitToggleCard{
  handleToggle: () => void;
}

const UrgentVisitToggleCard = ({ handleToggle }: IUrgentVisitToggleCard) => {
  const handleCardClick = () =>{
    handleToggle();
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-2">
        <div className="font-semibold text-sm">Need urgent care?</div>
        <div className="text-gray-1 text-sm">
        Book an urgent appointment for immediate medical attention.
        </div>
      </div>
      <div
        onClick={()=> handleCardClick()}
        className="cursor-pointer border border-taupe-50 flex gap-3 bg-white
      rounded-lg p-3 items-center hover:bg-gv-yellow-light hover:gv-yellow">
        <div className="flex items-center justify-center bg-taupe-5 rounded-full p-2 h-fit">
          <UrgentVisitIcon width={20} height={20} />
        </div>
        <div className="font-semibold text-sm">
            Book an Urgent Visit
        </div>
      </div>
    </div>
  );
};

export default UrgentVisitToggleCard;
